
import React, { useState } from 'react';
import { useUser } from '@/context/UserContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CycleImportRow } from '@/utils/cycle-tracking/import';
import { importCycleData } from '@/utils/cycle-tracking/import/importOperations';
import CycleImportHeader from './components/CycleImportHeader';
import CycleImportForm from './CycleImportForm';

const CycleImportController: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);
  
  const handleImportComplete = async (data: CycleImportRow[]) => {
    if (!user?.id) {
      toast.error('You must be logged in to import cycle data.');
      return;
    }
    
    setIsUploading(true);
    
    try {
      const success = await importCycleData(user.id, data);
      
      if (success) {
        toast.success('Cycle data imported successfully!');
        navigate('/cycle-tracking');
      } else {
        toast.error('Failed to import data. Please try again.');
      }
    } catch (error) {
      console.error('Error importing cycle data:', error);
      toast.error('Failed to import data. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };
  
  return (
    <div className="max-w-3xl mx-auto">
      <CycleImportHeader 
        isUploading={isUploading} 
        onBackClick={() => navigate('/cycle-tracking')} 
      />
      
      <CycleImportForm 
        onImportComplete={handleImportComplete} 
        isUploading={isUploading} 
      />
    </div>
  );
};

export default CycleImportController;
